import * as R from 'ramda';

export default function EditEndnotesDialogController(
  $scope,
  $rootScope,
  alerts,
  confirmDialog,
  editEndnoteDialog,
  editSectionDialog,
  deleteEndnoteConfirmDialog,
  loaderService,
  pmDataService,
  pmSharedModelService,
  ssDialogService,
) {
  const vm = this;
  vm.handleAdd = _handleAdd;
  vm.handleEdit = _handleEdit;
  vm.handleDelete = _handleDelete;
  vm.handleClose = _handleClose;
  vm.handleEditSection = _handleEditSection;

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleAdd($event) {
    return _showEditEndnoteDialog($event, {
      permissions: vm.permissions,
      policyDocumentId: vm.policyDocumentId,
      endnote: pmSharedModelService.getNewEndnote(vm.policyDocumentId)
    });
  }

  function _handleEdit($event, endnote) {
    return _showEditEndnoteDialog($event, {
      permissions: vm.permissions,
      policyDocumentId: vm.policyDocumentId,
      endnote,
    });
  }

  function _handleDelete($event, endnote) {
    ssDialogService.dialogs.pm.confirmDeleteEndnoteDialog = ssDialogService.alert(
      deleteEndnoteConfirmDialog.getOptions($event, {
        customerId: endnote.customerId,
        endnote,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.confirmDeleteEndnoteDialog);
  }

  function _handleEditSection($event, { policyDocumentSectionId }) {
    loaderService.showViewLoader = true;
    return pmSharedModelService.getSection(policyDocumentSectionId)
      .then((section) => {
        loaderService.showViewLoader = false;
        return _showEditSectionDialog($event, {
          permissions: vm.permissions,
          policyDocumentId: vm.policyDocumentId,
          section,
        });
      });
  }

  function _handleClose() {
    _closeDialog();
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    $scope.$on('pmEndnoteAdded', _handleAddedEndnote);
    $scope.$on('pmEndnoteDeleted', _handleDeletedEndnote);

    vm.endnotes = R.sortBy(R.prop('displayName'), vm.endnotes);
  }

  function _handleAddedEndnote(event, endnote) {
    vm.endnotes = vm.endnotes || [];
    vm.endnotes.push(endnote);
    if (vm.endnotes.length > 1) {
      vm.endnotes = pmSharedModelService.sort(vm.endnotes, 'tag');
    }
  }

  function _handleDeletedEndnote(event, policyDocumentEndNoteId) {
    if (!policyDocumentEndNoteId) return;
    const pos = vm.endnotes.findIndex(item => item.policyDocumentEndNoteId === policyDocumentEndNoteId);
    if (pos === -1) return; // Can't find the item
    vm.endnotes.splice(pos, 1);
  }

  function _showEditEndnoteDialog($event, locals) {
    ssDialogService.dialogs.pm.editEndnoteDialog = ssDialogService.alert(
      editEndnoteDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.editEndnoteDialog);
  }

  function _showEditSectionDialog($event, locals) {
    const dialogId = `editSectionDialog${locals.section.policyDocumentSectionId}`;
    ssDialogService.dialogs.pm[dialogId] = ssDialogService.alert(
      editSectionDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm[dialogId]);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.editEndnotesDialog);
  }
}

EditEndnotesDialogController.$inject = [
  '$scope',
  '$rootScope',
  'alerts',
  'confirmDialog',
  'editEndnoteDialog',
  'editSectionDialog',
  'deleteEndnoteConfirmDialog',
  'loaderService',
  'pmDataService',
  'pmSharedModelService',
  'ssDialogService',
];
